import React, { useEffect, useState } from 'react';
import InventoryData from '../../Datas/InventoryData';
import { WardDetails } from '../../Datas/WardDetails';
import './Notification.css';
import { FaExclamationTriangle, FaBox, FaClipboardList, FaCheckCircle } from 'react-icons/fa';

const NotificationPage = ({ role }) => {
  const [notifications, setNotifications] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const today = new Date();
    const notificationList = [];

    if (role === 'pharmacist') {
      const lowStockThreshold = 100;

      InventoryData.forEach(item => {
        const expiryDate = new Date(item.expiryDate);
        const daysToExpiry = (expiryDate - today) / (1000 * 60 * 60 * 24);

        if (daysToExpiry <= 120 && daysToExpiry >= 0) {
          notificationList.push({
            type: 'expiry',
            message: `${item.name} is expiring in ${Math.floor(daysToExpiry)} days.`,
            color: 'red',
            icon: <FaExclamationTriangle />,
          });
        }

        if (item.tablets < lowStockThreshold) {
          notificationList.push({
            type: 'stock',
            message: `${item.name} is low on stock (${item.tablets} tablets left).`,
            color: 'blue',
            icon: <FaBox />,
          });
        }
      });

      const indentDepartments = ['------']; 
      indentDepartments.forEach(department => {
        notificationList.push({
          type: 'indent',
          message: `A new indent was sent by the ${department} department.`,
          color: 'green',
          icon: <FaClipboardList />,
        });
      });
    } else if (role === 'ward') {
      const lowStockThreshold = 5;

      WardDetails.forEach(ward => {
        ward.inventory.forEach(item => {
          const expiryDate = new Date(item.expiryDate);
          const daysToExpiry = (expiryDate - today) / (1000 * 60 * 60 * 24);

          if (daysToExpiry <= 100 && daysToExpiry >= 0) {
            notificationList.push({
              type: 'expiry',
              message: `${item.name} is expiring in ${Math.floor(daysToExpiry)} days in the ${ward.wardName} ward.`,
              color: 'red',
              icon: <FaExclamationTriangle />,
              ward: ward.wardName,
              medicine: item.name,
            });
          }

          if (item.stockLevel <= lowStockThreshold) {
            notificationList.push({
              type: 'stock',
              message: `${item.name} is low on stock (${item.stockLevel} units left) in the ${ward.wardName} ward.`,
              color: 'blue',
              icon: <FaBox />,
              ward: ward.wardName,
              medicine: item.name,
            });
          }
        });
      });

      notificationList.push({
        type: 'indent-confirmed',
        message: `Indent for medication has been confirmed for the ${WardDetails[0].wardName} Department.`,
        color: 'green',
        icon: <FaCheckCircle />,
        ward: WardDetails[0].wardName,
        medicine: 'All confirmed items',
      });
    } else if (role === 'distributor') {
      const lowStockThreshold = 100;

      InventoryData.forEach(item => {
        const expiryDate = new Date(item.expiryDate);
        const daysToExpiry = (expiryDate - today) / (1000 * 60 * 60 * 24);

        if (daysToExpiry <= 120 && daysToExpiry >= 0) {
          notificationList.push({
            type: 'expiry',
            message: `${item.name} is expiring in ${Math.floor(daysToExpiry)} days.`,
            color: 'red',
            icon: <FaExclamationTriangle />,
          });
        }

        if (item.tablets < lowStockThreshold) {
          notificationList.push({
            type: 'stock',
            message: `${item.name} is low on stock (${item.tablets} tablets left).`,
            color: 'blue',
            icon: <FaBox />,
          });
        }
      });
    }

    setNotifications(notificationList);
  }, [role]);

  const handleFilterChange = (color) => {
    setFilter(color);
  };

  const filteredNotifications = filter === 'all'
    ? notifications
    : notifications.filter(notification => notification.color === filter);

  const handleCheckIndent = (department) => {
    alert(`Checking indent for ${department} department`);
  };

  const handleAddToCart = (itemName) => {
    alert(`Added ${itemName} to cart!`);
  };

  const handleCheckInventory = (itemName) => {
    alert(`Checked inventory for ${itemName}`);
  };

  const handleViewRevisedIndent = () => {
    alert('Viewing the revised indent.');
  };

  const handleConfirmIndent = () => {
    alert('Indent confirmed.');
  };

  return (
    <div className="notification-container">
      <div className="filter-container">
        <button className={`filter-button ${filter === 'all' ? 'active' : ''}`} onClick={() => handleFilterChange('all')}>All</button>
        <button className={`filter-button ${filter === 'red' ? 'active' : ''}`} onClick={() => handleFilterChange('red')}>Expiry</button>
        <button className={`filter-button ${filter === 'blue' ? 'active' : ''}`} onClick={() => handleFilterChange('blue')}>Out of Stock</button>
        {role === 'ward' && (
          <button className={`filter-button ${filter === 'green' ? 'active' : ''}`} onClick={() => handleFilterChange('green')}>Indent Confirmations</button>
        )}
        {role === 'pharmacist' && (
          <button className={`filter-button ${filter === 'green' ? 'active' : ''}`} onClick={() => handleFilterChange('green')}>Indents</button>
        )}
      </div>

      {filteredNotifications.length > 0 ? (
        filteredNotifications.map((notification, index) => (
          <div key={index} className={`notification-card purple-background`}>
            <div className={`notification-icon ${notification.color}`}>
              {notification.icon}
            </div>
            <div className="notification-content">
              <p>{notification.message}</p>
              <div className="button-container">
                {notification.type === 'stock' || notification.type === 'expiry' ? (
                  <>
                    <button className="action-button add-to-cart" onClick={() => handleAddToCart(notification.medicine || notification.message)}>Add to Cart</button>
                    <button className="action-button check-inventory" onClick={() => handleCheckInventory(notification.medicine || notification.message)}>Check Inventory</button>
                  </>
                ) : notification.type === 'indent' ? (
                  <button className="action-button check-indent" onClick={() => handleCheckIndent(notification.message.split(" ")[7])}>Check Indent</button>
                ) : notification.type === 'indent-confirmed' ? (
                  <>
                    <button className="action-button view-revised-indent" onClick={handleViewRevisedIndent}>View Revised Indent</button>
                    <button className="action-button confirm-indent" onClick={handleConfirmIndent}>Confirm</button>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div>No notifications at the moment.</div>
      )}
    </div>
  );
};

export default NotificationPage;
